module.exports = "/_next/static/images/tc-bfe93186f3bce04826a55070475d91eb.svg";